import React from 'react';

const MediaPreviewWithInfo = (props: { children: React.ReactNode }) => {
  const children = React.Children.toArray(props.children);

  return (
    <div className="mediaPreview">
      {children.map((child, i) => (
        <div className="mediaPreview-row" key={`media-preview-${i}`}>
          {child}
        </div>
      ))}
    </div>
  );
};

export default MediaPreviewWithInfo;
